// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import { setItem, getItem } from "~/es6/localstorage";
import { sklikRoutePlan } from "~/util/sklik";
import { saveHistory } from "~/util/providers/history";
import { trafficData, route as routeFRPC } from "~/route/provider";
import RouteParams from "~/route/params/main";
import RouteReadOnlyInfo from "~/route/read-only-info";
import { isPointInStatePolygon } from "~/util/state-polygon";
import { prepareSetting, setUserSettings } from "~/util/providers/mapybox";
import { ELoginState, ESETTINGS_KEYS, IUserMaxSpeedData } from "~/state/user/interfaces";
import { setSetting } from "~/state/user/state";
import { selectUserSettingsValue } from "~/state/user/selectors";
import Map from "~/route/map/main";
import { ROUTE_CONST } from "~/route/const";
import Info from "~/route/info";
import Items from "~/route/items";
import Loader from "~/route/loader";
import Routes from "~/route/routes";
import { providerParams, getRouteTripType } from "~/route/utils";
import { setGlobals, store, CONFIG, Scene, _, Notifications } from "~/route/globals";
import { NOTIFICATIONS_TYPE } from "~/util/notifications";
import { standardDistanceFormat, standardTimeFormat } from "~/util/format";
import { watch, watchCoordinates, watchSettingsUserSpeedChange, watchSettingsUserMaxSpeedChange } from "~/state/util";
import { Unsubscribe } from "redux";
import { isRouteReadOnly } from "./utils-common";
import { timeWithUserSpeed } from "~/util/user-speed";
import { getCriterion } from "~/util/route";
import { SECTION_ITEM_TYPE } from "~/route4/pt/const";

async function checkCriterionInState(criterions) {
	const { longitude, latitude } = store.getState().map;
	const inCZ = await isPointInStatePolygon(longitude, latitude, {
		cs: true,
	});
	let validCriterions = criterions || Mapy.CML.state.route.validCriterions;
	const planableCriterions = Mapy.CML.state.route.planableCriterions;

	// routovani vodakem jen v cr
	ROUTE_CONST.types.water.criterion.forEach(criterion => {
		if (inCZ && validCriterions.indexOf(criterion) == -1 && ((planableCriterions.length && planableCriterions.indexOf(criterion) > -1) || !planableCriterions.length)) {
			validCriterions.push(criterion);
		} else if (!inCZ && validCriterions.indexOf(criterion) > -1) {
			validCriterions.splice(validCriterions.indexOf(criterion), 1);

			const localStorageCriterion = parseInt(getItem(ESETTINGS_KEYS.ROUTING_WEB_DEFAULT_CRITERION));
			const saveCriterion = selectUserSettingsValue(store.getState(), ESETTINGS_KEYS.ROUTING_WEB_DEFAULT_CRITERION) || localStorageCriterion;

			if (criterion && criterion === parseInt(saveCriterion)) {
				Mapy.CML.state = {
					route: {
						params: {
							criterion: ROUTE_CONST.types.car.criterion[0], // defaultni kriterium
							type: ROUTE_CONST.TYPE_CAR,
						},
					},
				};
			}
		}
	});

	Mapy.CML.state = {
		route: {
			validCriterions,
		},
	};
}

function setUserSettingsParams(criterion) {
	if (criterion) {
		const { user, settings } = store.getState().user;
		const routingWebDefaultCriterion = settings.find(item => item.title === ESETTINGS_KEYS.ROUTING_WEB_DEFAULT_CRITERION);
		const actualSavedCriterion = routingWebDefaultCriterion?.data?.value;

		if (user.state === "green" && ((actualSavedCriterion && actualSavedCriterion !== criterion) || !actualSavedCriterion)) {
			const setting = prepareSetting(ESETTINGS_KEYS.ROUTING_WEB_DEFAULT_CRITERION, criterion);

			setUserSettings(setting);
			store.dispatch(setSetting(setting));
		}

		setItem(ESETTINGS_KEYS.ROUTING_WEB_DEFAULT_CRITERION, criterion);
	}
}

export function initModule(global) {
	setGlobals(global);
}

/**
 * Obal pro:
 * - hlavni trida
 */
export default class Route {
	_storeUnsubscribe: Unsubscribe;

	constructor(container: HTMLDivElement) {
		if (Mapy.CUS?.route?.anotherPUBTCriterion) {
			ROUTE_CONST.types.pubt.criterion = [200, 191, 193, 194, 195, 196, 197];
			ROUTE_CONST.types.pubt.subItems.push({
				type: "pubtSelect",
				name: "criterionSepcs",
				items: [{
					label: "Všechny",
					value: 200,
					checked: true,
				}, {
					label: "Bus",
					value: 191,
					checked: false,
				}, {
					label: "Tram",
					value: 193,
					checked: false,
				}, {
					label: "Metro",
					value: 194,
					checked: false,
				}, {
					label: "Cablecar",
					value: 195,
					checked: false,
				}, {
					label: "Ferry",
					value: 196,
					checked: false,
				}, {
					label: "Train",
					value: 197,
					checked: false,
				}],
			});
		}

		if (Mapy.CUS?.route?.datetimeForAll) {
			const datetime = {
				type: "pubt",
				name: "route-pubt",
				param: "pubt",
			};

			ROUTE_CONST.types.car.subItems.push({ ...datetime });
			ROUTE_CONST.types.bike.subItems.push({ ...datetime });
			ROUTE_CONST.types.trial.subItems.push({ ...datetime });
		}


		this._container = container;
		this._params = new RouteParams();
		this._readOnlyInfo = new RouteReadOnlyInfo();
		this._map = new Map();
		this._items = new Items(this._map);
		this._routes = new Routes();
		this._info = new Info();
		this._loader = new Loader(this._container);
		this._startItem = null;
		this._lids = [];
		this._reqObj = null;
		this._suggestMap = null;
		this._smTimeout = 0;
		this._redrawListener = null;
		this._storeUnsubscribe = null;
		this._storeUnsubscribeUserSpeed = null;
		this._storeUnsubscribeUserMaxSpeed = null;

		this._build();
		this._setListeners();
		// def. stav
		this.setDefaultState(/*Mapy.CML.state.route*/);
	}

	destroy() {
		this._storeUnsubscribeUserMaxSpeed?.();
		this._storeUnsubscribeUserSpeed?.();
		Mapy.CML.removeListeners(this._lids);
		this._loader.destroy();
		this._params.destroy();
		this._readOnlyInfo.destroy();
		this._items.destroy();
		this._detail.destroy();
		this._map.destroy();
		this._container.remove();
	}

	get container() {
		return this._container;
	}

	get defaultState() {
		let validCriterions = [];

		Object.values(ROUTE_CONST.types).forEach(type => {
			validCriterions = [
				...validCriterions,
				...type.criterion,
			];
		});

		return {
			status: 200,
			forced: false,
			likeData: null,
			likeDataChange: false,
			fromRawData: false,
			responseData: [],
			interaction: true,
			loading: false, // nacitaji se data?
			error: "", // chybova hlaska
			routeInd: -1, // vybrana trasa
			itinerary: false, // nacist itinerar
			itineraryOpen: false, // zobrazit itinerar
			heightProfile: false, // zobrazit vyskovy profil
			weatherOpen: false,
			scroll: false, // scrollovat po requestu
			zoom: false, // zoom na vysledky?
			forceZoom: false,
			index: 0,
			print: false, // tiskne se?
			clear: true,
			request: false,
			active: false,
			hoverIndex: 0,
			alternatives: true,
			loadItinerary: false,
			showGeometries: false,
			routingId: undefined,
			reroute: false,
			lastRouteDate: 0,
			toHistory: [],
			pubtIndex: [],
			selectedAlternative: false,
			showLabelInFrame: 0,
			fromHistory: false,
			validCriterions,
			planableCriterions: [],
			readOnly: false,
			userIsPremium: store.getState().user.user?.premium,
		}
	}

	setDefaultState(defState = {}) {
		let state = {
			route: {
				...this.defaultState,
				...this._params.defaultState,
				...this._items.defaultState,
				...defState,
			},
		};

		if (this._reqObj) {
			this._reqObj.request.abort();
			this._reqObj = null;
		}

		if (Mapy.getComponent("dimcurator") && Mapy.CML.state.route.likeData) {
			Mapy.getComponent("dimcurator").setState();
		}

		// nastavime
		Mapy.CML.state = state;
		Mapy.CML.state = {
			route: {
				clear: false,
			},
		};

		this._readOnlyInfo.visibility = false;

		// zapomeneme, ze uz videl navrzeny mapset
		try {
			sessionStorage.removeItem("suggestMap");
		} catch(ex) {}

		this._items.focusEmptyItem();

		checkCriterionInState();
	}

	show() {
		Mapy.CML.state = {
			route: {
				//active: true,
				showGeometries: true,
			}
		}

		this._map.active();
		this._setBottomPanel();
		this._items.focusEmptyItem();
		this._routes.show();
		this._readOnlyInfo.visibility = Mapy.CML.state.route.readOnly;

		Scene.getContainer().addEventListener("photo-gallery-close", this);
		Scene.getContainer().addEventListener("photo-detail-close", this);

		const wt = watch(store.getState, "map", watchCoordinates);

		this._storeUnsubscribe = store.subscribe(wt((newMap, oldMap) => {
			if (
				newMap.longitude !== oldMap.longitude
				|| newMap.latitude !== oldMap.latitude
				|| newMap.zoom !== oldMap.zoom
			) {
				this._mapRedraw();
			}
		}));
		this._mapRedraw();

		this._setSEO();

		if (Mapy.getComponent("dimcurator") && Mapy.CML.state.route.likeData && !Mapy.CML.state.route.likeDataChange) {
			Mapy.getComponent("dimcurator").setState({ dim: Mapy.CML.state.route.likeData.id });
		}
	}

	hide() {
		Mapy.CML.state = {
			route: {
				//active: false,
				showGeometries: false
			}
		}

		this._map.deactive();
		this._routes.hide();

		Scene.getContainer().removeEventListener("photo-gallery-close", this);
		Scene.getContainer().removeEventListener("photo-detail-close", this);

		this._storeUnsubscribe?.();
		this._storeUnsubscribe = null;

		if (Mapy.getComponent("dimcurator") && Mapy.CML.state.route.likeData) {
			Mapy.getComponent("dimcurator").setState();
		}
	}

	openParamsOptions() {
		this._params.openOptions();
	}

	handleEvent(e) {
		if (e.type == "photo-detail-close" || e.type == "photo-gallery-close") {
			Mapy.CML.state.route.active && !Mapy.getComponent("gallery").isActive() && this._setSEO();
		}
	}

	_showGeom(closure) {
		this._map.showGeom(closure);
	}

	_hideGeom() {
		this._map.hideGeom();
	}

	_build() {
		this._container.appendChild(this._params.container);
		this._container.appendChild(this._readOnlyInfo.container);
		this._container.appendChild(this._items.container);
		this._container.appendChild(this._routes.container);
		this._container.appendChild(this._info.container);
	}

	/**
	 * Nastaveni posluchacu.
	 */
	_setListeners() {
		// listener id => lid
		this._lids.push(Mapy.CML.addListener((items, state, fromRestore) => {
			if (fromRestore) return;
			if (items.length) {
				if (this._startItem && (this._startItem.id != items[0].id || this._startItem.source != items[0].source)) {
					Mapy.CML.state = {
						route: {
							weather: null
						}
					};
				}

				this._startItem = {
					id: items[0].id,
					source: items[0].source
				}
			}
			state.route.routingId = undefined;
			this._updateState(state.route);

			let stateswitch = Mapy.getComponent("stateswitch");
			if (!stateswitch) return;
			let stateS = stateswitch.getState("r");

			if (stateS && stateS.dom) {
				let elm = stateS.dom.querySelector("span.route-count");
				if (!elm) {
					elm = node("span", { className: "route-count" });
				}

				elm.classList.add("round");
				if (items.length) {
					elm.innerHTML = `<i>${items.length}</i>`;
					// tohle tu musi byt, nebo se stava, ze uz je elm sam tim firstChild a pak to v IE shori. Chyba je to vsude, ale ostatni se z toho nepominou
					if (stateS.dom.firstChild !== elm) {
						stateS.dom.firstChild.before(elm);
					}
				}
				else {
					elm.remove();
				}
			}
		}, "route.items"));

		this._lids.push(Mapy.CML.addListener((params, state, fromRestore) => {
			if (fromRestore) return;
			state.route.routingId = undefined;
			this._updateState(state.route);
		}, "route.params"));

		this._lids.push(Mapy.CML.addListener((params, state, fromRestore) => {
			if (fromRestore) return;

			if (state.route.forced) {
				this._updateState(state.route);
			}
		}, "route.forced"));

		this._lids.push(Mapy.CML.addListener((request, state) => {
			if (!Mapy.CML.state.route.active) { return; }

			if (request) {
				this.hide();
				this._hideGeom();
			}
			else {
				this._showGeom();
				this.show();
			}

			setUserSettingsParams(state.route.params?.criterion);
		}, "route.request"));

		this._lids.push(Mapy.CML.addListener((itinerary, state, fromRestore) => {
			if (fromRestore || !itinerary) return;
			Mapy.CML.state = {
				route: {
					loadItinerary: true,
				}
			};
			this._updateState(state.route);
		}, "route.itinerary"));

		this._lids.push(Mapy.CML.addListener((alternatives, state) => {
			this._map.showAlternatives = alternatives;
			this._routes.showAlternatives = alternatives;

			if (state.route.responseData.length <= 1) {
				this._updateState(state.route);
			}
		}, "route.alternatives"));

		this._lids.push(Mapy.CML.addListener((show, state) => {
			if (Mapy.CML.state.route.active) {
				return;
			}

			this[show ? "_showGeom" : "_hideGeom"](true);
		}, "route.showGeometries"));

		this._lids.push(Mapy.CML.addListener(responseData => {
			if (!Mapy.CML.state.route.active) {
				return;
			}

			!responseData.length && checkCriterionInState(this.defaultState.validCriterions);
		}, "route.responseData"));

		const wtUserMaxSpeed = watch(store.getState, "user.settings", watchSettingsUserMaxSpeedChange);

		this._storeUnsubscribeUserMaxSpeed = store.subscribe(wtUserMaxSpeed(newValue => {
			const state = Mapy.CML.state;
			const { user } = store.getState().user;

			if (state.route.responseData.length && user.premium) {
				this._updateState(state.route);
			}
		}));

		const wtUserSpeed = watch(store.getState, "user.settings", watchSettingsUserSpeedChange);

		this._storeUnsubscribeUserSpeed = store.subscribe(wtUserSpeed(newValue => {
			const state = Mapy.CML.state;

			if (state.route.responseData.length) {
				this._updateState(state.route);
			}
		}));
	}

	_updateState(routeState) {
		// mame 2+ vyplnenych itemu?
		if ((routeState.items.length >= 2 || (routeState.items.length == 1 && routeState.items[0].planTrip)) && (!routeState.loading || routeState.forced)) {
			this._request(routeState);
		}
		else {
			routeState.active && this._setSEO();
		}
	}

	_request(routeState) {
		let itms = Mapy.CML.state.route.items;

		// vymazani uzavirek, aby nedoslo k spojeni objektu
		if (itms && itms.length) {
			itms.forEach(i => {
				i.closures = [];
				i.warnings = [];
			})
		}

		if (!routeState.fromHistory) {
			sklikRoutePlan();
		}

		// stav nacitani
		Mapy.CML.state = {
			route: {
				loading: true,
				request: true,
				trafficLoaded: false,
				traffic: {},
				error: "",
				// kdyz se nacita itinerar, tak nechame routing id, jinak je treba ho promazat
				routingId: routeState.itinerary ? routeState.routingId : undefined,
				items: itms,
				responseData : [],
				fromHistory: false,
				active: true,
			}
		};

		let requestParams = providerParams(routeState);
		// obecne
		let items = itms;
		Mapy.CML.state = {
			route: {
				lastRouteDate: Date.now(),
			},
		};

		if (Mapy.CUS.route?.azimuth) {
			const azimuth = parseInt(this._params.azimuth);
			if (!isNaN(azimuth) && requestParams.length && requestParams[0].length && requestParams[0][0].routeParams) {
				requestParams[0][0].routeParams.azimuth = azimuth;
			}
		}

		if (Mapy.CUS.route.datetimeForAll && requestParams[0][0]?.routeParams?.datetime) {
			requestParams[1].useTraffic = false;
		}

		let carMaxSpeed = null;
		let maxSpeedEnabled = false;

		if (ROUTE_CONST.types.car.criterion.includes(routeState.params.criterion)) {
			const { settings, user } = store.getState().user;
			const maxSpeed = (user.premium ? (settings.find(item => item.title === ESETTINGS_KEYS.ROUTING_MAX_SPEED)?.data?.value || null) : null) as IUserMaxSpeedData;

			if (maxSpeed?.car) {
				carMaxSpeed = maxSpeed.car;
				maxSpeedEnabled = !!carMaxSpeed.maxSpeedEnabled;
			}

			if (maxSpeedEnabled) {
				requestParams[1].maxSpeedLimit = carMaxSpeed.maxSpeed;
			}
		}

		let reqObj = routeFRPC(requestParams);

		if (this._reqObj) {
			this._reqObj.request.abort();
		}

		this._reqObj = reqObj;

		reqObj.promise.then(response => {
			this._reqObj = null;

			let routes = [response];

			if ("altRoutes" in response) {
				routes = response.altRoutes;
			}

			let responseData = [];

			items.forEach(item => {
				if (!item) return;
				// reset parametru
				item.path = [];
				item.tripData = [];
				item.pubtData = [];
				item.boatData = [];
				item.routeData = [];
				item.closures = [];
				item.warnings = [];
				item.route_part_ids = [];
				item.commerce = null;
				item.favoriteId = "";
				item.usertitle = "";
				item.typeId = 0;
			});

			const route_part_ids = [];

			// sestavime kombinaci vsech prujezdnich zemi ze vsech moznosti
			let countryData = [];
			const usedCountriesIso = [];
			routes.forEach(r => {
				r.countryData.forEach(country => {
					if (usedCountriesIso.indexOf(country.iso3) === -1) {
						countryData.push({
							iso3: country.iso3,
							name: country.name,
						});
						usedCountriesIso.push(country.iso3);
					}
				});
			});

			/*
			countryData = countryData.filter(country => {
				if (usedCountries.indexOf(country.iso3) === -1) {
					usedCountries.push(country.iso3);

					return true;
				}

				return false;
			}).map(country => {
				return Object.assign({}, country, { ignore: true });
			});
			*/

			routes.forEach((r, index) => {
				let geom = [];

				// sestavime prujezdni zeme
				const usedCountries = r.countryData.map(country => country.iso3);
				const routeCountryData = r.countryData.map(country => {
					return Object.assign({}, country);
				});
				const departureDate = routeState.params.datetime
					? routeState.params.departure
						? new Date(routeState.params.datetime)
						: new Date(new Date(routeState.params.datetime).getTime() - (r.totalTime * 1000))
					: new Date();

				countryData.forEach(country => {
					if (usedCountries.indexOf(country.iso3) === -1) {
						routeCountryData.push(country);
					}
				});

				responseData[index] = {
					altitude: r.altitude,
					countryData: routeCountryData,
					totalLength: r.totalLength,
					totalTime: r.totalTime,
					itinerary: [],
					routeWaypoints: r.routeWaypoints || "",
					markerCoords: null,
					index: index,
					routeId: r.route_id,
					// MHD si tohle prepise nize, pokud je to potreba
					walk: ROUTE_CONST.types.trial.criterion.indexOf(routeState.params.criterion) !== -1,
					departureISO: departureDate.toISOString(),
					firstTrafficDepartureISO: departureDate.toISOString(),
				};

				r.routes.forEach((i, ind) => {
					let item = items[ind];

					// dalsi data
					if (i.routes && i.routes.length) {
						let routeData = i.routes[0].data;
						let routeParams = i.routeParams;

						item.routeData[index] = {
							length: routeData.length,
							time: routeData.time,
						};

						// celkovy odjezd
						if (ind === 0 && routeData.departureISO) {
							responseData[index].departureISO = routeData.departureISO;

							// prvni odjezd po pesim useku
							if (routeData.items?.length && routeData.items[0].type === SECTION_ITEM_TYPE.walk) {
								responseData[index].walk = true;

								// mame vic nez jeden usek a prvni byl pesky, takze cas, kdy to jede zaznamename z druheho useku, protoze po prvni chuzi druhy nebude cekani, ale opravdu jizda
								if (routeData.items.length > 1) {
									if (routeData.items[1].departureISO) {
										responseData[index].firstTrafficDepartureISO = routeData.items[1].departureISO;
									}
								}
							// neco se pokazilo, tak si proste jako fallback rekneme, ze jede a to ve chvili, kdy to cele zacina
							} else {
								responseData[index].walk = false;
								responseData[index].firstTrafficDepartureISO = routeData.departureISO;
							}
						}

						// jen pro dopravu chceme dopravni situaci
						if (routeState.params.useTraffic && routeData.route_part_id) {
							route_part_ids.push(routeData.route_part_id);
							item.route_part_ids[index] = routeData.route_part_id;
						}

						if ("routePoint" in routeData) {
							responseData[index].itinerary.push(routeData.routePoint);
						}

						if ("geometry" in routeData) {
							item.path[index] = routeData.geometry;
							let coords = Scene.stringToCoords(routeData.geometry);

							if (coords.length) {
								// pokud je posledni a prvni stejnej
								if (geom.length && geom[geom.length-1].x == coords[0].x && geom[geom.length-1].y == coords[0].y) {
									coords.shift();
								}

								geom = geom.concat(coords);
							}

							delete routeData.geometry;
						}

						if ("closures" in routeData && routeData.closures.length) {
							item.closures[index] = routeData.closures;
						}

						if ("warnings" in routeData && routeData.warnings.length) {
							item.warnings[index] = routeData.warnings;
						}

						if (i.tripParams) {
							item.tripData[index] = routeData;
							item.tripData[index].tripParams = i.tripParams;

							// spravne data pro cas a delku u vyletu
							if (i.tripParams && routeData.triplist) {
								responseData[index].totalLength = routeData.triplist[routeData.index >= 0 ? routeData.index : 0].length;
								responseData[index].totalTime = routeData.triplist[routeData.index >= 0 ? routeData.index : 0].time;
							}

							if ("triplist" in routeData) {
								item.tripData[index].waypoints = "";
							}
							else {
								item.tripData[index].triplist = null;
							}
						}

						if (routeParams && ROUTE_CONST.types.water.criterion.indexOf(routeParams.criterion) > -1 && routeData) {
							item.boatData[index] = {
								pois: routeData.pois,
								poisTitle: routeData.poisTitle
							};
						}

						const isPUBT = routeParams && routeParams.criterion == ROUTE_CONST.types.pubt.criterion[0];

						if (routeParams && isPUBT && routeData) {
							item.pubtData[index] = JSON.stringify(routeData);
						}

					}

					if (i.commerce) {
						item.commerce = i.commerce;
					}
				});

				if (geom.length) {
					if (r.popupIndex) {
						responseData[index].markerCoords = geom[r.popupIndex].toWGS84();
						responseData[index].markerAzimuth = r.popupAzimuth;
					}
					else {
						responseData[index].markerCoords = geom[Math.round((geom.length-1)/2)].toWGS84();
					}
				}

				responseData[index].geometry = Scene.coordsToString(geom);
			});

			if (Mapy.getComponent("print").mode === 3 && responseData[0]) {
				Mapy.getComponent("route").createOGContent(responseData[0].totalLength, responseData[0].totalTime);
			}

			// pokud mam zjistovat nejaka data k doprave, tak se na ne zeptam
			if (route_part_ids.length) {
				Mapy.CML.state = {
					route: {
						trafficLoaded: false,
						trafficTotalTime: [],
					},
				};

				// prisla data k doprave, naparuju je k route_part_id (na to reaguje route/map tim, ze prekresli geometrie)
				trafficData(route_part_ids, requestParams[0][0].routeParams.datetime, maxSpeedEnabled).promise.then(response => {
					const traffic = {};

					if (response.status >= 200 && response.status < 300 && response.data) {
						response.data.parts.forEach(part => {
							traffic[part.route_part_id] = part.traffic;
						});

						const trafficTotalTime = [];

						if (Mapy.CUS.route.datetimeForAll || maxSpeedEnabled) {
							responseData.forEach(route => {
								let totalTime = 0;
								const keys = Object.keys(traffic).filter(key => key.indexOf(route.routeId) > -1);
								const speedMS = maxSpeedEnabled ? carMaxSpeed.maxSpeed / 3.6 : Infinity;

								keys.forEach(key => {
									traffic[key].forEach(routeSection => {
										if (routeSection.time) {

											if (maxSpeedEnabled) {
												const routeSectionSpeed = routeSection.length/routeSection.time;

												if (routeSectionSpeed > speedMS) {
													totalTime += routeSection.length / speedMS;
												} else {
													totalTime += routeSection.time;
												}
											} else {
												totalTime += routeSection.time;
											}
										}
									});
								});

								trafficTotalTime.push(Math.round(totalTime));
							});
						}

						Mapy.CML.state = {
							route: {
								traffic,
								trafficLoaded: true,
								trafficTotalTime,
							},
						};
					}
				}, () => {});
			}

			routes[0].routes.forEach((i, ind) => {
				let item = items[ind];

				if (!item) return;
				// obohatime data
				item.images = i.images;
				item.title = i.name || "";
				item.desc = i.multiTitle ? i.multiTitle.filter((i, ind) => i.trim() && ind > 0).join(", ") : (i.desc || i.description || "");
				if (i.typeId) {
					item.typeId = i.typeId;
				}

				if (i.favoriteId) {
					item.favoriteId = i.favoriteId;
					item.usertitle = i.name || "";
				}

				if (i.source == "coor") {
					item.title = Mapy.getComponent("gps").coordsToFormat(Scene.stringToCoords(i.geometry)[0]);
				}
			});

			let scroll = true;

			if (typeof routeState.scroll === "number") {
				scroll = routeState.scroll;
			}

			// odstranime hlasky o chybach
			Notifications.hideAll([NOTIFICATIONS_TYPE.SUCCESS]);

			this._sendToHistory();

			// zkusime nabidnout jinou mapu, pokud to dava smysl
			if (!CONFIG.inFrame) {
				this._offerDifferentMapset();
			}

			let newIndex = 0;
			if (response.selectedAlternative) {
				newIndex = response.selectedAlternative;
			}
			else if (Mapy.CML.state.route.loadItinerary) {
				newIndex = routeState.index;
			}

			let newState = {
				responseData,
				forced: false,
				scroll, // chceme po nacteni dat kotvit tlacitka
				items,
				routeInd: 0, // def. routa
				error: "",
				index: newIndex,
				likeDataChange: Mapy.CML.state.route.reroute ? Mapy.CML.state.route.likeDataChange : Mapy.CML.state.route.likeData && !Mapy.CML.state.route.fromRawData && !Mapy.CML.state.route.loadItinerary,
				routingId: response.routing_id,
				routeWaypoints: "",
				toHistory: [],
				selectedAlternative: response.selectedAlternative != undefined,
				status: response.status,
				errorObject: null,
				readOnly: isRouteReadOnly(routeState.userIsPremium, routeState.params, !!routeState.items[0].planTrip),
				...response?.planableCriterions?.length
					? {
						validCriterions: response.planableCriterions,
						planableCriterions: response.planableCriterions,
					}
					: {},
			};

			if (Mapy.CML.state.route.likeData && !Mapy.CML.state.route.fromRawData && !Mapy.CML.state.route.loadItinerary) {
				if ("owner_name" in Mapy.CML.state.route.likeData) {
					newState.likeData = null;
					newState.likeDataChange = false;
				}
				else {
					Mapy.getComponent("dimcurator").setState();
					Mapy.getComponent("history").save();
				}
			}

			// nastavime stav
			Mapy.CML.state = {
				route: newState
			};

			this._readOnlyInfo.visibility = newState.readOnly;
			this._setSEO();
			this._setBottomPanel();

			// je hotovo, zrusime loading
			Mapy.CML.state = {
				route: {
					scroll: false,
					zoom: false,
					forceZoom: false,
					loading: false,
					request: false,
					loadItinerary: false,
					reroute: false,
				}
			};

			if (response.selectedAlternative != undefined) {
				this._map.showAlternatives = false;
				this._routes.showAlternatives = false;

				setTimeout(() => {
					Mapy.CML.state = {
						route: {
							alternatives: false,
						}
					}
				})
			}

			Mapy.getComponent("history").save(true).finally( () => {
				this._analytics(response, maxSpeedEnabled); // anylytika az po ulozeni dat do url
			});
		}, response => {
			this._reqObj = null;
			let items = Mapy.CML.state.route.items;

			items.forEach(item => {
				if (!item) return;
				// reset parametru
				item.path = [];
				item.tripData = [];
				item.pubtData = [];
				item.boatData = [];
				item.routeData = [];
			});

			this._sendToHistory();

			let errorObject = null;

			(response.altRoutes ? response.altRoutes[0]?.routes || [] : []).forEach(route => {
				if (route?.routes?.[0]?.error) {
					errorObject = { ...route.routes[0] };
				}
			});

			Mapy.CML.state = {
				route: {
					items,
					status: response.status,
					scroll: false,
					forced: false,
					zoom: false,
					forceZoom: false,
					responseData: [],
					routeInd: -1,
					request: false,
					error: response.statusMessage,
					index: 0,
					itinerary: false,
					loadItinerary: false,
					routingId: undefined,
					routeWaypoints: "",
					reroute: false,
					toHistory: [],
					selectedAlternative: false,
					errorObject,
					...response?.planableCriterions?.length
						? {
							validCriterions: response.planableCriterions,
							planableCriterions: response.planableCriterions,
						}
						: {},
				}
			};

			// naschval az po predchozi zmene stavu, aby to vyvolalo nove kolo callbacku
			Mapy.CML.state = {
				route: {
					loading: false
				}
			};

			this._readOnlyInfo.visibility = false;
			this._setSEO();

			// vsechno mozna ok, ale chteli jsme vec z cache a ta tam neni
			if (response.status === 410) {
				Mapy.CML.state = {
					route: {
						reroute: true
					}
				};
				this._updateState(Mapy.CML.state.route);
			}
		});
	}

	_setSEO() {
		let routeState = Mapy.CML.state.route;

		// jeste nejsou vysledky, jen itemy
		if (!routeState.responseData[routeState.index]) {
			if (routeState.items.length) {
				Mapy.SEO.set(_("route." + (routeState.items[0].position == ROUTE_CONST.position.end ? "seoTo" : "seoFrom"), routeState.items[0].title), _("route.seoDescription"), _("route.seoKeywords"));
			}
			else {
				if (routeState.params.type == ROUTE_CONST.TYPE_PUBT) {
					Mapy.SEO.set(_("route.pt.seoTitle"), _("route.seoDescription"), _("route.seoKeywords"));
				}
				else {
					Mapy.SEO.set(_("route.seoTitle"), _("route.seoDescription"), _("route.seoKeywords"));
				}
			}
		}
		else {
			let title = _("route.seoTitle");

			// pouze vylet, protoze mame jen 2 itemy a presto mame vysledky
			if (routeState.items.length == 1 && routeState.items[0].tripData) {
				title = _("route.seoTrip", this._getResultTitle(routeState.items[0]));
			}
			else {
				let type = 1;

				switch (routeState.params.type) {
					case ROUTE_CONST.TYPE_CAR: type = 1; break;
					case ROUTE_CONST.TYPE_BIKE: type = 2; break;
					case ROUTE_CONST.TYPE_WALK: type = 3; break;
					case ROUTE_CONST.TYPE_PUBT: type = 4; break;
					case ROUTE_CONST.TYPE_SKI: type = 5; break;
					case ROUTE_CONST.TYPE_BOAT: type = 6; break;
				}
				title = _("route.result.seo" + type, {
					from: this._getResultTitle(routeState.items[0]),
					to: this._getResultTitle(routeState.items[routeState.items.length - 1])
				});
			}

			Mapy.SEO.set(
				title,
				_("route.seoDescription"),
				_("route.seoKeywords")
			);
		}
	}

	_getResultTitle(res) {
		let title = "";

		if (res.title) {
			title = res.title;

			if (res.title && res.desc && res.desc !== "") {
				title +=  `, ${res.desc}`;
			}
		}
		else if (res.geometry) {
			title = Scene.stringToCoords(res.geometry)[0].toWGS84(2).reverse().join(", ");
		}
		else {
			title = _("coordinates");
		}

		return title;
	}

	_setBottomPanel() {
		let routeState = Mapy.CML.state.route;

		if (routeState.responseData[routeState.index]) {
			Mapy.getComponent("layout").setBottomPanel(node("h4", {
				className: "bp-route",
				innerHTML: _("route.result.bottomText", standardDistanceFormat(routeState.responseData[routeState.index].totalLength).string + " &ndash; " + standardTimeFormat(timeWithUserSpeed(routeState.responseData[routeState.index].totalTime, getCriterion(routeState))).string)
			}));
		}
	}

	_analytics(response, maxSpeedEnabled) {
		let routeState = Mapy.CML.state.route;
		let isTrip = routeState.items.length ? !!routeState.items[0].tripData[routeState.index] : false;
		let length = isTrip ? routeState.items[0].tripData[routeState.index].length : routeState.responseData[routeState.index] ? routeState.responseData[routeState.index].totalLength : 0;

		var logdata = {
			count: routeState.items.length,
			from: Scene.stringToCoords(routeState.items[0].geometry)[0].toWGS84().join(","),
			to: Scene.stringToCoords(routeState.items[routeState.items.length - 1].geometry)[0].toWGS84().join(","),
			routeType: isTrip ? routeState.params.tripCriterion : routeState.params.criterion,
			circuit: isTrip,
			status: response.status || 503, // 503 je Service Unavailable a to zni jako spravna volba pro stav, kdy odpoved je tak zla, ze nema v sobe ani status
			length: length || 0,
			viaFerrata: routeState.params.allowViaFerrata,
			route_time_option: routeState.params.datetime
				? routeState.params.departure
					? "departAt"
					: "arriveBy"
				: "now",
			maxSpeedLimited: maxSpeedEnabled,
		};

		let cze = false;
		let countries = [];
		let countries_avoid = [];
		if (routeState.responseData && routeState.responseData.length) {
			routeState.responseData.forEach(res => {
				if (res.countryData && res.countryData.length) {
					let isos = res.countryData.map(cd => {
						if (cd.totalLength > 0) {
							return cd.iso3;
						}

						return "";
					});

					if (isos.indexOf("CZE") > -1) {
						cze = true;
					}

					res.countryData.forEach(country => {
						if ([112, 114].indexOf(routeState.params.criterion) == -1 && routeState.params.excludeCountries.indexOf(country.iso3) == -1 && countries.indexOf(country.iso3) == -1) {
							countries.push(country.iso3);
						}
					});

					let exclude = [];
					if ([112, 114].indexOf(routeState.params.criterion) == -1) {
						exclude = routeState.params.excludeCountries.filter(iso => {
							return isos.indexOf(iso) != -1 && countries_avoid.indexOf(iso) == -1;
						});

					}
					else {
						exclude = isos.filter(iso => {
							return countries_avoid.indexOf(iso) == -1;
						});
					}

					countries_avoid = countries_avoid.concat(exclude);
				}
			});
		}

		// pokud jedeme autem po CR, posleme jeste info o tom, jestli jedeme s dopravou
		if (ROUTE_CONST.TYPE_CAR_FAST_CRITERIONS.indexOf(logdata.routeType) !== -1 && !!routeState.params.useTraffic) {
			logdata.withTraffic = cze;
		}

		if (routeState.params.type == ROUTE_CONST.TYPE_CAR && !isTrip) {
			logdata.countries = countries;
			logdata.countries_avoid = countries_avoid;
		}

		Mapy.getComponent("logger").log("route", logdata);
	}

	// poslani ulozenych entit do uzivatelske historie, pokud zaroutujeme/zmenime routovani (pridame bod)
	_sendToHistory() {
		let toHistory = Mapy.CML.state.route.toHistory;

		if (toHistory instanceof Array && toHistory.length) {
			const { user } = store.getState().user;

			saveHistory(user, toHistory).then(() => {}, () => {});
		}
	}

	_offerDifferentMapset() {
		// na mobilech a malych zarizenich nic
		if (Mapy.Util.isSmallResolution()) {
			return;
		}

		const onAccept = () => {
			this._suggestMap = null;

			setItem("suggestMap", "1");
		};

		function onDecline() {
			const seenTimes = getItem("suggestMap") || 0;

			setItem("suggestMap", (parseInt(seenTimes) + 1).toString());
		}

		// pokud uz jsme v tehle session napovidali, tak znovu uz ne
		try {
			const suggested = sessionStorage.getItem("suggestMap");
			if (suggested) {
				return;
			}
		} catch(ex) {}

		// pokud uz to videl mockrat, tak taky nic
		const seenTimes = getItem("suggestMap");

		if (seenTimes && parseInt(seenTimes) >= 20) {
			return;
		}


		// najdeme tu spravnou mapu, nebo to vzdame
		const routeState = Mapy.CML.state.route;
		const isTrip = !!routeState.items[0].planTrip;

		if (isTrip && !routeState.items[0]?.tripParams?.criterion) {
			return;
		}

		const rType = isTrip ? getRouteTripType(routeState.items[0].tripParams) : routeState.params.type;
		const { mapset } = store.getState().map;
		let map = "";

		// nejsme na nektere ze zakladnich map - koncime
		if (["zakladni", "dopravni", "turisticka", "zimni"].indexOf(mapset) === -1 || Scene.isM3dActive()) {
			return;
		}

		if (rType === ROUTE_CONST.TYPE_CAR && mapset !== "dopravni") {
			map = "car";
		} else if(rType === ROUTE_CONST.TYPE_BIKE && mapset !== "turisticka") {
			map = "bike";
		} else if(rType === ROUTE_CONST.TYPE_WALK && mapset !== "turisticka") {
			map = "turist";
		} else if(rType === ROUTE_CONST.TYPE_SKI && mapset !== "zimni") {
			map = "ski";
		}

		if (map === "") {
			return;
		}

		// pokud je timeout jeste v akci, tak ho zastavime, protoze by uz zaviral novy popups
		if (this._smTimeout) {
			clearTimeout(this._smTimeout);
		}

		// vsechny podminky splneny - ukazeme to
		const mapToLog = {
			car: "e_traffic",
			bike: "a_default",
			turist: "a_default",
			ski: "b_winter",
		};
		this._suggestMap = new Mapy.SuggestMap({
			map: map,
			onAccept: onAccept,
			onDecline: onDecline,
			mapToLog: mapToLog,
		});
		this._suggestMap.open();
		Mapy.getComponent("logger").log("map_banner_impress", { type: mapToLog[map] });

		// zaznamename, ze v tehle session uz to videl
		try {
			sessionStorage.setItem("suggestMap", "1");
		} catch(ex) {}

		// za 10s schovat, at se deje, co se deje
		this._smTimeout = setTimeout(() => {
			if (this._suggestMap) {
				this._suggestMap.close();
				onDecline();
				Mapy.getComponent("logger").log("map_banner_no_action", { type: mapToLog[map] });
				this._suggestMap = null;
			}
		}, 10000);
	}

	// eslint-disable-next-line class-methods-use-this
	_mapRedraw() {
		if (!Mapy.CML.state.route.responseData.length) {
			checkCriterionInState();
		}
	}
}
